import { Input } from "@/components/views/add-place/Input";
import AtSymbolIcon from "@heroicons/react/24/solid/AtSymbolIcon";
import KeyIcon from "@heroicons/react/24/solid/KeyIcon";
import { useEffect } from "react";
import { MAX_PASSWORD_LENGTH, MIN_PASSWORD_LENGTH } from "@/auth";
import QuoteUsageTerms from "../UsageTerms";
import { useSession } from "next-auth/react";
import isMailPassable from "@/lib/is-mail-passable";
import { useTranslation } from "@/hooks/translationContext";

interface Props {
  data: any;
  setData: any;
  setValidStep: (state: boolean) => void;
}

export default function RegisterScreen(props: Props) {
  const { t } = useTranslation();
  const { data, setData, setValidStep } = props;

  const { status: sessionStatus } = useSession();

  const onChange = (key: string, value: any) => {
    setData({
      ...data,
      [key]: value,
    });
  };

  const validPassword = () => {
    if (data?.password?.length === 0) return true;

    return (
      data?.password?.length >= MIN_PASSWORD_LENGTH &&
      data?.password?.length < MAX_PASSWORD_LENGTH
    );
  };

  const isAgreed = () => data?.isAgreed === true;
  const validMail = () => data?.email && isMailPassable(data?.email);

  useEffect(() => {
    if (!(data.password.length > 0 && validPassword() && validMail() && isAgreed())) {
      setValidStep(false);
      return;
    }

    setValidStep(true);
  }, [data?.password, data?.email, data?.isAgreed]);

  return (
    <div className="flex flex-col justify-between md:h-[calc(100vh-480px)] md:max-h-[500px] md:!min-h-[340px] gap-4 md:pb-6">
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-4 w-full">
          <Input
            disabled={sessionStatus == "authenticated"}
            className="shadow border border-slate-300"
            value={data?.email}
            error={!validMail()}
            onChange={(e: ReactEvents.ChangeEvent<HTMLInputElement>) => {
              onChange("email", e.target.value);
            }}
            placeholder="E-Posta Adresiniz"
            id="email"
            icon={<AtSymbolIcon className="size-5" />}
          />

          <div className="flex flex-col gap-1 text-center">
            <label className="text-[10px] text-secondary font-medium">
              Ücretsiz üye olmak için şifrenizi belirleyiniz
            </label>
            <Input
              className="shadow border border-slate-300"
              value={data?.password}
              error={!validPassword()}
              errorMessage={t("quote-page-password-length-warning", {
                min: MIN_PASSWORD_LENGTH,
                max: MAX_PASSWORD_LENGTH,
              })}
              onChange={(e: ReactEvents.ChangeEvent<HTMLInputElement>) => {
                setData({
                  ...data,
                  password: e.target.value,
                } as any);
              }}
              placeholder={t("user-login-password-placeholder")}
              id="venue-password"
              type="password"
              icon={<KeyIcon className="size-5" />}
            />
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-4 inset-inline-end">
        <div
          className="w-full p-2 font-medium text-sm flex flex-col gap-1 rounded-[24px]">
          <div className="text-xs font-medium">
            Talebiniz İşletmelere iletilmiştir.
          </div>

          <div className="text-assistant font-medium text-xs">
            İşletmeler size vermiş olduğunuz iletişim bilgilerinden Telefon
            araması, Whatsapp ve ya Mail ile bağlatı kurabilirler.
          </div>
        </div>

        <QuoteUsageTerms />
      </div>
    </div>
  );
}
